import { render, staticRenderFns } from "./ydbphotopopup.vue?vue&type=template&id=5024c98c&scoped=true&"
import script from "./ydbphotopopup.vue?vue&type=script&lang=js&"
export * from "./ydbphotopopup.vue?vue&type=script&lang=js&"
import style0 from "./ydbphotopopup.vue?vue&type=style&index=0&id=5024c98c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024c98c",
  null
  
)

export default component.exports